export default __webpack_public_path__ + "static/media/SME.90ae5575.png";